import React from "react";
import { useHistory } from "react-router-dom";
import LogoSVG from "../../../assets/icons/logo.svg";
export const Logo: React.FC = () => {
  const history = useHistory();
  return <img src={LogoSVG} alt="" className="w-[66px] h-[70px] cursor-pointer mb-[46px]" onClick={() => history.push("/")} />;
};
